"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TRANSLATION = exports.HOTEL_BOOKING_LABEL = exports.DEFAULT_CHIP_VALUES = void 0;
var TRANSLATION = {
  firstLabel: 'Search other bookings',
  title: 'Search for a booking',
  subTitle: 'Use your booking number to search for your booking',
  hotel: 'Hotel',
  flight: 'Flight',
  searchInstructions: 'You can purchase add-ons in 3 easy steps:',
  searchInstruction1: '1. Enter your booking number, family name/surname, and departure city.',
  searchInstruction2: '2. Select the add-ons you wish to purchase.',
  searchInstruction3: '3. Pay using your preferred payment channel.',
  hotelNotificationBannerText: 'Have a hotel booking with AirAsiaGO?',
  hotelNotificationBannercta: 'Retrieve Booking',
  hotelNotificationBannerURL: 'https://www.airasiago.com.au/user/itin',
  invalidBookingNOtificationBannerText: 'We cant find your booking. Please ensure that all the details are entered correctly',
  viewBookings: 'View all your bookings',
  search: 'Search'
};
exports.TRANSLATION = TRANSLATION;
var DEFAULT_CHIP_VALUES = {
  BACKGROUND_COLOR: 'default',
  TEXT_COLOR: 'neutral',
  BORDER_COLOR: 'greyLight',
  FONT_SIZE: 'small',
  HOVER: {
    BACKGROUND_COLOR: 'default',
    TEXT_COLOR: 'secondary',
    BORDER_COLOR: 'secondary'
  },
  ACTIVE: {
    BACKGROUND_COLOR: 'blue',
    TEXT_COLOR: 'default',
    BORDER_COLOR: 'secondary'
  }
};
exports.DEFAULT_CHIP_VALUES = DEFAULT_CHIP_VALUES;
var HOTEL_BOOKING_LABEL = 'hotel';
exports.HOTEL_BOOKING_LABEL = HOTEL_BOOKING_LABEL;